import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
/**
 * Memoized wrapper that renders children unchanged.
 * Use inside a context Provider so that when the provider re-renders (e.g. on state update),
 * the subtree does not re-render unless the `children` prop reference changes.
 * Only components that actually consume the context will re-render when context value changes.
 */ export const StableChildren = /*#__PURE__*/ React.memo(function StableChildren({ children }) {
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
});
